export const enum TrafficSegment {
  AllCustomers = 'all-customers',
  Chatting = 'chatting',
  Supervised = 'supervised',
  Queued = 'queued',
  WaitingForReply = 'waiting-for-reply',
  Invited = 'invited',
  Browsing = 'browsing',
}
